export const updateSession = async (
  method: string,
  body: Record<string, any>,
  sessionTrigger: (value: boolean) => void,
) => {
  return fetch('/api/auth/session', {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => {
    // After updating session, session needs to be fetched again
    sessionTrigger(true)
    return res.json()
  })
}
